import React from 'react';
import Button from '@mui/material/Button';

export default function OutlinedButton(props) {
  return <Button {...props} />;
}
